
































































































































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Card from '@/components/Card.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import { ICheckboxSelectItem } from '../../../../interfaces'
import { CONSTANTS, EOrigin, EUserStatus, IUser, IUserChainRole } from '@zunta/configurations'
import { NoCache } from '@/decorators/NoCache'
import { UserModule } from '@/store/modules/user.module'
import DateInput2 from '@/components/inputs/DateInput2.vue'
import { MODULE_ITEMS, PHONE_MASK } from '@/constants'
import { ChainModule } from '@/store/modules/chain.module'
import Icon from '@/components/Icon.vue'
import Switcher from '@/components/Switcher.vue'
import Api from '@/api'
import SelectV2 from '@/components/inputsV2/SelectV2.vue'
import MultiSelectV2 from '@/components/inputsV2/MultiSelectV2.vue'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import TextareaV2 from '@/components/inputsV2/TextareaV2.vue'
import { email, required, sameAs } from 'vuelidate/lib/validators'
import InputValidator from '@/components/inputsV2/InputValidator.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'

const { SALES_REP_ROLE_NAME } = CONSTANTS

@Component({
  components: {
    LoaderWrapper,
    Card,
    Icon,
    Checkbox,
    DateInput2,
    Switcher,
    SelectV2,
    MultiSelectV2,
    InputV2,
    TextareaV2,
    InputValidator
  }
})
export default class CreateChainComponent extends Vue {
  userModuleInstance: UserModule = getModule(UserModule, this.$store)
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)
  PHONE_MASK: string = PHONE_MASK

  selectedModules = []
  totalFacilities: string = ''
  facilitiesToOnboard: string = ''
  isEmailSentChecked: boolean = false
  comments: string = ''
  salesRepresentativeId: number | null = null
  billingSoftware: string | null = null
  sandbox: boolean = false
  name: string = ''
  isFcc: boolean = false
  startDate: any = null

  isLoading: boolean = false

  modulesItems: ICheckboxSelectItem[] = MODULE_ITEMS.map((item, index) => {
    return {
      content: item.content,
      value: item.value,
      key: index.toString(),
      selected: false
    }
  })

  users: Array<any> = [
    {
      firstName: '',
      lastName: '',
      title: '',
      email: '',
      phone: '',
      extension: '',
      cellPhone: ''
      // isMainPointOfContant: false
    }
  ]

  get billingSoftwareItems () {
    return [
      {
        key: 'BOTH',
        value: 'BOTH',
        content: 'Both'
      },
      ...Object.keys(EOrigin).map((item) => {
        return {
          key: EOrigin[item as keyof typeof EOrigin],
          value: EOrigin[item as keyof typeof EOrigin],
          content: EOrigin[item as keyof typeof EOrigin]
        }
      })
    ]
  }

  get chainId () {
    return this.$route.params.id
  }

  get chain () {
    return this.$store.state.chain.chain
  }

  @NoCache
  get salesReps () {
    return this.$store.state.user.users.filter((user: IUser) => (
      (user.role as IUserChainRole).name === SALES_REP_ROLE_NAME
    ))
  }

  get salesRepsItems () {
    return this.salesReps.map((user: IUser) => {
      return {
        key: user.id,
        value: user.id,
        content: `${user.firstName} ${user.lastName}`
      }
    })
  }

  validations (): any {
    return {
      name: { required },
      billingSoftware: { required },
      selectedModules: { required },
      facilitiesToOnboard: { required },
      totalFacilities: { required },
      salesRepresentativeId: { required },
      startDate: { required },
      isEmailSentChecked: { required: sameAs(() => true) },
      users: {
        $each: {
          firstName: { required },
          lastName: { required },
          title: { required },
          email: { required, email },
          phone: {
            required,
            phone: (val: any) => /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/.test(val)
          }
        }
      }
    }
  }

  async mounted () {
    try {
      this.isLoading = true
      await this.userModuleInstance.getAdminUsersList({
        limit: 1000,
        status: EUserStatus.ACTIVE
      })

      if (this.chainId) {
        await this.chainModuleInstance.fetchChain({
          id: this.chainId,
          relations: ['salesRepresentative', 'accountManager']
        })

        if (this.chain) {
          this.salesRepresentativeId = this.chain.salesRepresentative.id
          this.billingSoftware = this.chain.billingSoftware
          this.sandbox = this.chain.sandbox
          this.name = this.chain.name
          this.isFcc = this.chain.isFcc
          this.totalFacilities = this.chain.totalFacilities
          this.facilitiesToOnboard = this.chain.facilitiesToOnboard
          this.comments = this.chain.comments
          this.modulesItems.forEach((item: ICheckboxSelectItem) => {
            if (this.chain.modules.includes(item.value)) {
              item.selected = true
            }
          })
        }
      }
    } finally {
      this.isLoading = false
    }
  }

  addUser () {
    this.users.push({
      firstName: '',
      lastName: '',
      title: '',
      email: '',
      phone: '',
      extension: '',
      cellPhone: ''
      // isMainPointOfContant: false
    })
  }

  deleteUser (index: number) {
    this.users.splice(index, 1)
  }

  // isMainContactDisabled (user: any) {
  //   const foundUser = this.users.find((user) => user.isMainPointOfContant)
  //   return foundUser ? foundUser !== user : false
  // }

  async submit () {
    this.$v.$touch()
    if (this.$v.$anyError) {
      return
    }

    const userEmails = this.users.map(user => user.email)
    if (userEmails && userEmails.length) {
      const emailStatusesMap: Record<string, boolean> = await Api.user.getIsEmailsAvailable(userEmails)
      // false means email is taken
      // === comparison is for avoiding converting undefined to false
      const existingEmails: string[] = this.users
        .filter((user: IUser) => emailStatusesMap[user.email] === false)

      if (existingEmails && existingEmails.length) {
        existingEmails.forEach((user: any) => {
          this.$eventBus.$emit('notify', {
            color: 'var(--status-error-color)',
            message: `${user.email} is already registered in Zunta`,
            header: `Error`,
            icon: 'warning'
          })
        })
        return
      }
    }

    // if (!this.chainId && !this.users.find((user) => user.isMainPointOfContant)) {
    //   this.$eventBus.$emit('notify', {
    //     color: 'var(--status-error-color)',
    //     message: 'Must have main point contact',
    //     header: `Error`,
    //     icon: 'warning'
    //   })
    //   return
    // }

    try {
      this.isLoading = true
      if (this.chainId) {
        await this.chainModuleInstance.updateChainOnboarding({
          chainId: this.chainId,
          data: {
            name: this.name,
            salesRepresentativeId: this.salesRepresentativeId,
            billingSoftware: this.billingSoftware,
            sandbox: this.sandbox,
            isFcc: this.isFcc,
            totalFacilities: this.totalFacilities,
            facilitiesToOnboard: this.facilitiesToOnboard,
            startDate: this.startDate,
            comments: this.comments,
            modules: this.selectedModules,
            users: this.users
          }
        })
      } else {
        await this.chainModuleInstance.createOnboardingChain({
          name: this.name,
          salesRepresentativeId: this.salesRepresentativeId,
          billingSoftware: this.billingSoftware,
          sandbox: this.sandbox,
          isFcc: this.isFcc,
          totalFacilities: this.totalFacilities,
          facilitiesToOnboard: this.facilitiesToOnboard,
          startDate: this.startDate,
          comments: this.comments,
          modules: this.selectedModules,
          users: this.users
        })
      }
      await this.$router.push({ name: 'admin-chains' })
    } finally {
      this.isLoading = false
    }
  }
}
